export enum ModalType {
  Warning = 'warning',
  Info = 'info',
  Dialog = 'dialog',
  FullScreen = 'full-screen'
}

export interface Modal<P = {}> {
  id?: number;
  componentId: string;
  type: ModalType;
  closeBtn: boolean;
  props?: P;
}
